export interface DataSyncMetricsBucket {
  bucket: string;
  tracker_id: string;
  datasync_id: string;
  stage: string;
  total_success_count?: number | string;
  total_error_count?: number | string;
  total_duration_ms?: number | string;
  event_count?: number | string;
}

export interface GetDataSyncMetricsResponse {
  metrics_buckets: DataSyncMetricsBucket[];
}

export enum DataSyncHealthStatus {
  HEALTHY = 'HEALTHY',
  WARNING = 'WARNING',
  FAILING = 'FAILING',
}

export interface DataSyncMetricsSummary {
  datasyncId: string;
  totalEvents: number;
  totalErrors: number;
  successRate: number;
  errorRate: number;
  sparklineData: number[];
  healthStatus: DataSyncHealthStatus;
}
